<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Receipts',
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('receipt/reset')
    this.$store.dispatch('systemSetting/loadSystemSettings')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/receipts/index.vue